/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const LinkedIn = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M5.56463 3.31973C5.56463 4.59184 4.51701 5.63946 3.31973 5.63946C2.12245 5.63946 1 4.51701 1 3.31973C1 2.04762 2.04762 1 3.31973 1C4.59184 1 5.56463 2.04762 5.56463 3.31973ZM5.56463 7.43537H1V22.0272H5.56463V7.43537ZM12.898 7.43537H8.33333V22.0272H12.898C12.898 22.0272 12.898 16.5646 12.898 14.3197C12.898 10.0544 18.4354 9.68027 18.4354 14.3197C18.4354 16.415 18.4354 22.0272 18.4354 22.0272H23C23 22.0272 23 16.7143 23 12.7483C23 5.56463 14.8435 5.78912 12.898 9.38095V7.43537Z"
                        fill={color}
                    />
                </svg>
        );
    };
